import { render, staticRenderFns } from "./NewTasks.vue?vue&type=template&id=e92aa0e8"
import script from "./NewTasks.vue?vue&type=script&lang=js"
export * from "./NewTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports